module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.433f0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/fullscreen-image_hero_600.png
// module id = 0oUD
// module chunks = 0